import Title from "components/shared/Title";
import LinkGroup from "components/shared/LinkGroup";
import Link from "components/shared/Link";

const mainClass = "help-section-item";

const SectionItem = ({
	icon,
	name,
	description,
	isLinkGroup,
	link,
	headingType,
}) => {
	if (isLinkGroup) {
		return (
			<LinkGroup
				icon={icon}
				title={name}
				subTitle={description}
				link={link}
				parentClass={mainClass}
			/>
		);
	}

	return (
		<div className={mainClass}>
			<Title
				headingType={headingType}
				title={name}
				subTitle={description}
			></Title>
			<Link {...link} />
		</div>
	);
};

export default SectionItem;
